export const statusEvent = {
  close: 'close',
  reopen: 'reopen',
};
